import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import './nasMedia.css';
import "./settings.css";
import Navbar from './settingNav';
import DeleteMediaDialog from "../../setting/ManageMedia/deleteMedia/deleteMediaDialog";
// import '../../setting/ManageMedia/CloudPortal.css'
import {
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import { FaFileAlt, FaFolder, } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import httpService from "../../../services/http.service";
import CapchaDeleteMediaDialog from "../../setting/ManageMedia/deleteMedia/capchaDelete";
import SuccessMessage from "../../common/successMsg";
import Loader from "../../common/loader";
import ErrorMessage from "../../common/errorMsg";
const NasMedia = (props) => {
    const [selectedUser, setSelectedUser] = useState("");
    const [modalusertDeleteOpen, setModaluserDeleteOpen] = useState(false);
    const [userConformtDeleteOpen, setUserConformDeleteOpen] = useState(false);
    const [deleteUserPath, setDeleteUserPath] = useState("")
    const [folderStructure, setFolderStructure] = useState([])
    const [openFolderName, setOpenFolderName] = useState('')
    const [nasUser, setNasUser] = useState({})

    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("")


    const [files, setFiles] = useState([]);
    const [folderUsage, setFolderUsage] = useState([])
    // useEffect(() => {
    //     if (props.users?.length == 0)
    //         props.fetchUsers()
    // }, [props.users])

    const handleUserChange = (event) => {
        setSelectedUser(event.target.value);
    };


    const getNASUserFiles = async () => {
        try {
            if (selectedUser !== "") {
                let response = await httpService.get(`/show-user-bucket-files?userID=${selectedUser}`)
                setFiles(response.data.files)
            }
            else {
                let response = await httpService.get("/gcp-user-folders")
                setFolderUsage(response.data.data)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    function formatBytes(bytes) {
        if (bytes === 0) return '0 Bytes';

        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        const value = bytes / Math.pow(1024, i);

        return `${value.toFixed(2)} ${sizes[i]}`;
    }



    const deleteNasUser = (path) => {
        // alert(path)
        setNasUser(path)
        setDeleteUserPath(`${path.customerId}`)
        setModaluserDeleteOpen(!modalusertDeleteOpen)
    }

    const CanceldeleteModelNasUser = () => {
        setModaluserDeleteOpen(!modalusertDeleteOpen)
    }
    const conformdeleteNasUser = () => {
        setUserConformDeleteOpen(!userConformtDeleteOpen)
        setModaluserDeleteOpen(false)


    }

    const deleteNasUserConform = async () => {
        // alert(deleteUserPath)
        setLoading(true)
        setMsg("Deleting Nas User...")
        setUserConformDeleteOpen(!userConformtDeleteOpen)
        await httpService.get(`gcp-user-folder-delete?fileName=${deleteUserPath}`)
            .then(async (res) => {
                console.log(res.data);
                if (res?.data?.ack === "1") {
                    setMsg("Cancel NAS Subcription...")

                    // deleteItem(false)

                    try {
                        let data = {
                            id: nasUser._id,
                            type: nasUser.type,
                            startDateNas: "",
                            endDateNas: "",
                            nasSpace: "0"
                        };
                        let returnData = await httpService
                            .CreateUpdate("savelicence", data)
                            .then((res) => res.data)
                            .catch((err) => {
                                if (err && err.response && err.response.status === 401) {
                                    ErrorMessage("Session expired, please login again")
                                }
                                return
                            });

                        // hideLoader();
                        if (returnData.ack === "1") {
                            props.fetchUsers()
                            setLoading(false)

                            //   SuccessMessage("NAS Info has been updated Successfully.")
                            SuccessMessage(`${deleteUserPath} Nas Data has been Removed`)


                        } else {
                            setLoading(false)

                            ErrorMessage(returnData.message)
                            return;
                        }
                        setLoading(false)

                        // props.loadAllData();
                    } catch (e) {

                    }

                    // setModaluserDeleteOpen(false)



                }

                return res.data?.data

            })
            .catch((err) => {
                console.log({ err });
                return null
            });

    }

    const cancledeleteNasUser = () => {
        // setModaluserDeleteOpen(!modalusertDeleteOpen)
        setUserConformDeleteOpen(!userConformtDeleteOpen)

    }

    const toggleFolder = (folderName) => {
        if (folderName === openFolderName)
            setOpenFolderName('')
        else
            setOpenFolderName(folderName)

    };
    const colorEndDay = (nasenddate) => {
        const currentDate = new Date();
        const endDate = new Date(nasenddate);
        const timeDiff = endDate - currentDate;
        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        if (daysRemaining <= 10) {
            // Interpolate color between light red and dark red as days decrease
            const redIntensity = Math.min(225, 225 - ((11 - daysRemaining) * 20));
            console.log(redIntensity)
            return < div style={{ color: `rgb(255, ${redIntensity}, ${redIntensity})` }}>Subscription ending in {daysRemaining} day </div>

        }
        return < div style={{ color: "black" }}>Subscription ending in {daysRemaining} day</div>
    }

    function organizeFilesByFolder(files) {
        const structure = [];
        files.forEach(file => {
            const path = file.name.split('/').filter(Boolean).slice(1);
            const name = path[0];
            const isFolder = path.length > 1;

            const existing = structure.find(item => item.name === name);

            if (isFolder) {
                if (existing) {
                    existing.fileCount++;
                    existing.size += file.size;
                } else {
                    structure.push({ name, type: 'folder', size: file.size, fileCount: 1 });
                }
            } else {
                structure.push({ name, type: 'files', size: file.size });
            }
        });
        console.log(333, structure)
        setFolderStructure(structure)
    }

    const FilesRow = ({ file }) => {
        const isFolder = file?.type === 'folder';
        const isOpen = openFolderName === file.name;
        const [folderFiles, setFolderFiles] = useState([])
        useEffect(() => {
            if (isFolder) {
                const tempFolderfiles = files.filter(ele => ele.name.includes(file.name))
                setFolderFiles(tempFolderfiles.map(ele => ({ ...ele, folderName: file.name, name: ele.name.split('/').at(-1) })))
            }
        }, [])
        return <>
            <tr key={file.name} >
                <td className="">
                    <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingLeft: file.folderName ? 36 : 16 }}>
                        {isFolder && (
                            <span onClick={() => toggleFolder(file.name)} style={{ cursor: 'pointer' }}>
                                {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
                            </span>
                        )}
                        {isFolder ? <FaFolder /> : <FaFileAlt />}
                        <span>{file.name}</span>
                    </div>
                </td>
                <td className="">{file?.fileCount ?? '--'}</td>
                <td className="">
                    {file.size / 1e6 < 1
                        ? `${(file.size / 1e3).toFixed(2)} KB`
                        : `${(file.size / 1e6).toFixed(2)} MB`}
                </td>
            </tr>
            {(isOpen && folderFiles.length > 0) &&
                folderFiles.map(ele => <FilesRow file={ele} />)}
        </>
    }

    useEffect(() => {
        if (files?.length)
            organizeFilesByFolder(files)
    }, [files])
    
    useEffect(() => {
        getNASUserFiles()
    }, [selectedUser])

    return (<>
        {loading ? <Loader msg={msg} w="1swed" /> : null}
        <div style={{ margin: "15px" }}>
            <Navbar activeTab={"NasMedia"} />

            <div className="form-boxdiv2" >
                <div className="form-boxtopline5">
                    MANAGE RCC Cloud USERs
                </div>
                <div className="cloud-portal">
                    <div className="main-content">
                        <div className="files-section">
                            <div className="file-controls">
                                <div className='serch-input'>
                                    {/* <div className="input-icons">
                                        <input type="text" placeholder="Search Something..." value={searchInput}
                                            onChange={handleSearchChange} />
                                        <i className='fa fa-search erch-icon'></i>
                                    </div>
                                    <button className='btn btn-primary' onClick={openDialog} disabled={!selectedUser}>
                                        <i className='fa fa-plus mr-2'></i>Add New Folder
                                    </button> */}
                                    {/* <Modal isOpen={isAddDialogOpen} toggle={closeDialog}>
                                        <ModalHeader toggle={closeDialog}><strong>Create New folder</strong></ModalHeader>
                                        <ModalBody>
                                            <AddFolderDialog onClose={closeDialog} />
                                        </ModalBody>
                                    </Modal> */}
                                    {/* <button className='btn btn-primary' onClick={openImportfiles} disabled={!selectedUser}>
                                        <i className="fa fa-upload mr-2"></i>Import Files
                                    </button>
                                    <Modal isOpen={modalimportopen} toggle={toggleModal}>
                                        <ModalHeader toggle={toggleModal}><strong>Import Files</strong></ModalHeader>
                                        <ModalBody>
                                            <ImportMediaDialog onClose={toggleModal} />
                                        </ModalBody>
                                    </Modal> */}
                                </div>
                                <div className="sorting-main">
                                    <div className="file-heading">
                                        <h3>{selectedUser ? "Files" : "Users"}</h3>
                                        <div className="file-searching">
                                            <select className="selected" onChange={handleUserChange}>
                                                <option value="">User List</option>
                                                {folderUsage && folderUsage.map((user, indx) => {
                                                    console.log("User folder : ", user)
                                                    return <option key={indx} value={user._id}>{user.customerId}</option>
                                                })}
                                            </select>
                                            {/* <div>
                                                <div className="delete-user">
                                                    <button onClick={opendeleteUsers} className="btn btn-primary">Delete Users</button>
                                                </div>
                                                <Modal isOpen={isDeleteUsers} toggle={closeDeleteUsers}>
                                                    <ModalHeader toggle={closeDeleteUsers}><strong>Delete Users</strong></ModalHeader>
                                                    <ModalBody>
                                                        <DeleteNasUsers onClose={closeDeleteUsers} />
                                                    </ModalBody>
                                                </Modal>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {selectedUser &&
                                <div className='file-list-boxdiv2'>
                                    <table className="file-list">
                                        <thead>
                                            <tr className='list-head'>
                                                <th>Files/Folders Name</th>
                                                <th>File Count</th>
                                                <th>Size</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {folderStructure.map(file => (
                                                <>
                                                    <FilesRow file={file} />
                                                </>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            }
                            {!selectedUser && (
                                <div className='form-boxdiv2' style={{ overflow: "auto", height: "55vh" }}>
                                    {folderUsage?.length > 0 ?
                                        <table>
                                            <tr style={{ position: "sticky", top: 0 }}>
                                                <th>User</th>
                                                <th>Used Space</th>
                                                <th>Allocated Space</th>
                                                <th>Subscription Expire Date</th>
                                                <th style={{ textAlign: "center" }} >Users Cloud Storage Delete</th>

                                            </tr>
                                            {folderUsage?.map((user) => (

                                                <tr key={user.customerId}>
                                                    <td>{user.customerId}</td>
                                                    {user.storage > 0 ? <td>{formatBytes(user.storage)}</td> : <td>0.00 KB</td>}
                                                    {<td>{user.nasSpace} GB</td>}
                                                    <td>{(user.endDateNas && (user.nasSpace > 0)) ? (<div>{user.endDateNas}<br></br>{colorEndDay(user.endDateNas)}</div>) : "not subscribed"}</td>

                                                    <td style={{ textAlign: "center" }} onClick={() => deleteNasUser(user)}><i className="fa fa-trash delete-icon"></i></td>
                                                </tr>
                                            ))}
                                        </table>
                                        : <div className="paragraph">
                                            <p>No User Data</p>
                                        </div>}
                                    <Modal isOpen={modalusertDeleteOpen} toggle={CanceldeleteModelNasUser}>
                                        <ModalHeader toggle={CanceldeleteModelNasUser}><strong>Alert!</strong></ModalHeader>
                                        <ModalBody>
                                            <DeleteMediaDialog onClose={CanceldeleteModelNasUser} onClick={conformdeleteNasUser} msg="Are you sure to delete this Nas User Data ?" />
                                        </ModalBody>
                                    </Modal>
                                    <Modal isOpen={userConformtDeleteOpen} toggle={cancledeleteNasUser}>
                                        <ModalHeader toggle={cancledeleteNasUser}><strong>Alert!</strong></ModalHeader>
                                        <ModalBody>
                                            <CapchaDeleteMediaDialog onClose={cancledeleteNasUser} onConfirm={deleteNasUserConform} msg="DELETE" />
                                        </ModalBody>
                                    </Modal>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
};
export default NasMedia;